import { notification } from 'antd'
import { useTranslation } from 'react-i18next'
import { useMutation, useQueryClient } from 'react-query'

import { QUERY_KEYS } from '@api'
import { AxiosErrorType } from '@types'

import { ticketFilesApi } from './api'

const useTicketFiles = () => {
  const queryClient = useQueryClient()
  const { t } = useTranslation()
  const onError = (error: unknown) => {
    const errorData = error as AxiosErrorType

    if (errorData.data.error.message.toLowerCase() === 'extension not allowed') {
      notification.error({
        message: t('globals.ticket_file_upload.format_error'),
      })
    } else if (errorData.data.error.type.toLowerCase() === 'invalid_file_size') {
      notification.error({
        message: t('globals.ticket_file_upload.file_size_error'),
      })
    } else {
      notification.error({
        message: t('globals.ticket_file_upload.generic_error'),
      })
    }
  }
  const { mutate: uploadFile, isLoading } = useMutation(
    [QUERY_KEYS.UPLOAD_TICKET_FILES],
    ticketFilesApi.ticketFiles,
    {
      onError,
      onSuccess: () => {
        notification.success({
          message: t('globals.ticket_file_upload.successful_upload'),
        })
        queryClient.invalidateQueries([QUERY_KEYS.TICKET])
      },
    },
  )
  const { mutate: getFile } = useMutation(
    [QUERY_KEYS.GET_TICKET_FILE_URL],
    ticketFilesApi.getTicketFileUrl,
    {
      onError,
    },
  )

  const { mutate: downloadFile, isLoading: isDownloading } = useMutation(
    [QUERY_KEYS.DOWNLOAD_TICKET_FILE],
    ticketFilesApi.downloadTicketFile,
  )

  return {
    uploadFile,
    getFile,
    isLoading,
    downloadFile,
    isDownloading,
  }
}

export default useTicketFiles
